import React from "react";
import { faBoxes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { NavLink } from "react-router-dom";

export default function InfoBox( { title = "card title", total = 0, icon = faBoxes, link = null } ) {
    const getIconColor = ( title ) => {
        if ( title.includes( "Producto" ) ) return "#0d6efd";
        if ( title.includes( "Usuario" ) ) return "#198754";
        if ( title.includes( "Categoría" ) ) return "#fd7e14";
        if ( title.includes( "Valor" ) ) return "#6f42c1";
        return "#0d6efd";
    };

    const iconColor = getIconColor( title );

    const cardClass = "card card-body mt-2";

    return(
        <div className={cardClass}>
            <div className="d-flex justify-content-around w-100 align-content-center align-items-center">
                <div className="text-center">
                    <div style={{ marginBottom: "10px" }}>
                        <FontAwesomeIcon color={iconColor} size={"3x"} icon={icon}/>
                    </div>
                    <div>
                        {
                            link ?
                                <NavLink to={`/${link}`}>
                                    {title}
                                </NavLink>
                                :
                                <span style={{ fontWeight: 600, color: "#495057" }}>{title}</span>
                        }
                    </div>
                </div>
                <div className="text-center"><h1 className="superSize">{total}</h1></div>
            </div>

        </div>
    );
}